import React from 'react';
import { Card, Button } from 'antd';
import { withRouter } from "react-router";

class ServiceEntry extends React.Component {


  handleGoForDetails = () => {
    const { user } = this.props;
    const serviceEntry = this.props.serviceEntry;
    if (!user) {
      this.props.history.push({ pathname: `/service-entries/${serviceEntry.id}` });
    } else {
      this.props.history.push({ pathname: `/admin/services/${serviceEntry.id}` });
    }
  }

  render() {
    const serviceEntry = this.props.serviceEntry;
    return (
      <Card>
        <div style={{ height: 150, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }} >
          <div>
            <p style={{ fontSize: 18, fontWeight: 700, marginBottom: 10 }}>{serviceEntry.name}</p>
            <p style={{ fontSize: 14, fontWeight: 400, color: 'hsl(201, 23%, 34%)', marginBottom: 0 }}>{serviceEntry.description}</p>
          </div>
          <div>
            <Button type="primary" onClick={this.handleGoForDetails}>Go for details</Button>
          </div>
        </div>
      </Card>
    )
  }
}

export default withRouter(ServiceEntry);